<script setup lang="ts">
import { UiText, UiChip } from "@shopexperts/shared";

defineProps<{
  levelTitle: string | null;
  commissionLabel: string | null;
  rateLabel: string | null;
}>();
</script>

<template>
  <div
    class="flex flex-wrap items-center gap-x-4 gap-y-2 rounded-lg border border-se-gray-200 bg-gradient-to-r from-se-gray-50 to-white px-3 py-2.5"
  >
    <div v-if="levelTitle" class="flex flex-col leading-tight">
      <UiText as="span" variant="caption" class="text-se-gray-500" text="Level applied" />
      <UiText as="span" variant="p-small" :text="levelTitle" class="font-semibold text-se-dark" />
    </div>

    <div v-if="commissionLabel" class="flex flex-col leading-tight">
      <UiText as="span" variant="caption" class="text-se-gray-500" text="Commission charged" />
      <UiText as="span" variant="p-small" :text="commissionLabel" class="font-semibold text-se-dark" />
    </div>

    <UiChip
      v-if="rateLabel"
      :text="`${rateLabel} level rate`"
      variant="neutral"
      size="xs"
      rounded="full"
      class="ml-auto"
    />
  </div>
</template>
